<div class="add-container position-relative">
    <h1 class="add-title">Adaugă proiect</h1>

    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col-8">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Denumire Proiect</mat-label>
                    <input type="text" matInput formControlName="subject" />
                    <mat-error *ngIf="!form.controls['subject'].valid && form.controls['subject'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Proiect</mat-label>
                    <mat-select formControlName="scale">
                        <mat-option *ngFor="let row of project_type" [value]="row.value">
                            {{ row.key }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['scale'].valid && form.controls['scale'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tag Proiect</mat-label>
                    <input type="text" matInput formControlName="tag" [matAutocomplete]="auto" />
                    <mat-icon matSuffix class="opacity-50">search</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let tag of searchedTags" [value]="tag.name"
                            (onSelectionChange)="onTagSelected(tag)">
                            {{ tag.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!form.controls['tag'].valid && form.controls['tag'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
                <mat-error *ngIf="!form.controls['id_tag'].valid && form.controls['tag'].touched" class="mb-4">
                    Selectați în urma căutării un tag existent din lista de tag-uri
                </mat-error>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-center align-items-center">
                <mat-form-field>
                    <mat-label>Direcție</mat-label>
                    <mat-select formControlName="id_directie" (selectionChange)="onDirectieChange($event.value)">
                        <mat-option *ngFor="let directie of directiiActive$ | async" [value]="directie.id">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col d-flex justify-content-center align-items-center">
                <mat-form-field>
                    <mat-label>Compartiment</mat-label>
                    <mat-select formControlName="id_compartiment">
                        <mat-option *ngFor="let compartiment of compartimenteActive$ | async" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Secțiune</mat-label>
                    <mat-select formControlName="id_sectiune" (selectionChange)="onSectiuneChange($event.value)">
                        <mat-option *ngFor="let row of sectiuni$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_sectiune'].valid && form.controls['id_sectiune'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Categorie</mat-label>
                    <mat-select formControlName="id_categorie">
                        <mat-option *ngFor="let row of categoriiActive$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_categorie'].valid && form.controls['id_categorie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Furnizor</mat-label>
                    <mat-select formControlName="tip_furnizor" (selectionChange)="onTipFurnizoriChange($event.value)">
                        <mat-option *ngFor="let row of provider_type" [value]="row.value">
                            {{ row.key }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['tip_furnizor'].valid && form.controls['tip_furnizor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Furnizor</mat-label>
                    <mat-select formControlName="id_provider">
                        <mat-option *ngFor="let row of furnizoriActive$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_provider'].valid && form.controls['id_provider'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Dată început</mat-label>
                    <input matInput [matDatepicker]="pickerInceput" formControlName="data_inceput" readonly
                        (focus)="pickerInceput.open()" />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerInceput"></mat-datepicker-toggle>
                    <mat-datepicker #pickerInceput></mat-datepicker>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-error *ngIf="!form.controls['data_inceput'].valid && form.controls['data_inceput'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Dată șfârșit</mat-label>
                    <input matInput [matDatepicker]="pickerSfarsit" formControlName="data_finalizare" readonly
                        (focus)="pickerSfarsit.open()" />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerSfarsit"></mat-datepicker-toggle>
                    <mat-datepicker #pickerSfarsit></mat-datepicker>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-error
                        *ngIf="!form.controls['data_finalizare'].valid && form.controls['data_finalizare'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col">
                <mat-error *ngIf="form.hasError('dateRange')">Data de sfârșit nu poate fi mai mică decât
                    data de început</mat-error>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col">
                <div id="map" style="height:300px; width:100%"></div>
                <!-- google-maps-demo.component.html 
                <google-map id="map" height="250px" width="100%" [center]="center" [zoom]="zoom"
                    (mapClick)="moveMap($event)" (mapMousemove)="move($event)">
                    <map-marker [position]="markerPosition" [position]="markerPosition"></map-marker>
                </google-map>

                <div>Latitude: {{display?.lat}}</div>
                <div>Longitude: {{display?.lng}}</div>
                -->
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Introduceți locația proiectului</mat-label>
                    <input type="text" matInput formControlName="addressName" [matAutocomplete]="places" />
                    <mat-icon matSuffix class="opacity-50">search</mat-icon>
                    <mat-autocomplete #places="matAutocomplete">
                        <mat-option *ngFor="let place of searchedPlaces" [value]="place.locatie"
                            (onSelectionChange)="onPlaceSelected(place)">
                            {{ place.locatie }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="!form.controls['addressName'].valid && form.controls['addressName'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
                <mat-error
                    *ngIf="(!form.controls['lat'].valid || !form.controls['lng'].valid) && form.controls['addressName'].touched"
                    class="mb-2">
                    Selectați o adresă!
                </mat-error>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Observații locație</mat-label>
                    <textarea matInput formControlName="addressObs" name="addressObs"></textarea>
                    <mat-error *ngIf="!form.controls['addressObs'].valid && form.controls['addressObs'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Descriere</mat-label>
                    <textarea matInput formControlName="description" name="description"></textarea>
                    <mat-error *ngIf="!form.controls['description'].valid && form.controls['description'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="document-upload mb-3">
            <div class="document-upload-header">
                <p class="upload-text">Fotografii/Documente</p>
                <button class="upload-btn" (click)="fileInput.click()" type="button">
                    <mat-icon class="upload-icon me-2">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="document-upload-files" *ngIf="
                    form.value.files.length > 0 &&
                    !uploading
                ">
                <div class="document-upload-file" *ngFor="
                        let uploadedFile of form.value.files;
                        let i = index
                    ">
                    <span class="document-upload-file-name">
                        {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name | slice : 0 : 30) + ".."
                        : uploadedFile.original_name
                        }}
                    </span>
                    <div>
                        <button class="document-upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat"
                            (click)="removeFile(i)">
                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event, 'file')" multiple
                style="display: none" />
        </div>


        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>